import { PressImageProps } from './interfaces';
import Image from '../../Image/Image';
import { ImageProps } from '@uikit/components/Image/interfaces';
import PressImage from './PressImage';
type PressImageWrapperProps = PressImageProps | ImageProps;

const PressImageWrapper = (props: PressImageWrapperProps) => {
  if ((props as PressImageProps).assetLink) {
    return <PressImage {...(props as PressImageProps)} />;
  } else {
    return <Image {...(props as ImageProps)} />;
  }
};

export default PressImageWrapper;
